import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css'; // Ensure styles are applied from projects.css

const interiorRadImages = [
  { id: 1, thumbnail: '../images/interior-rad/interior-rad1.jpg', fullImage: '../images/interior-rad/interior-rad1.jpg' },
  { id: 2, thumbnail: '../images/interior-rad/interior-rad2.jpg', fullImage: '../images/interior-rad/interior-rad2.jpg' },
  { id: 3, thumbnail: '../images/interior-rad/interior-rad3.jpg', fullImage: '../images/interior-rad/interior-rad3.jpg' },
  { id: 4, thumbnail: '../images/interior-rad/interior-rad4.jpg', fullImage: '../images/interior-rad/interior-rad4.jpg' },
  { id: 5, thumbnail: '../images/interior-rad/interior-rad5.jpg', fullImage: '../images/interior-rad/interior-rad5.jpg' },
  { id: 6, thumbnail: '../images/interior-rad/interior-rad6.jpg', fullImage: '../images/interior-rad/interior-rad6.jpg' },
  { id: 7, thumbnail: '../images/interior-rad/interior-rad7.jpg', fullImage: '../images/interior-rad/interior-rad7.jpg' },
  { id: 8, thumbnail: '../images/interior-rad/interior-rad8.jpg', fullImage: '../images/interior-rad/interior-rad8.jpg' },
  { id: 9, thumbnail: '../images/interior-rad/interior-rad9.jpg', fullImage: '../images/interior-rad/interior-rad9.jpg' },
  { id: 10, thumbnail: '../images/interior-rad/interior-rad10.jpg', fullImage: '../images/interior-rad/interior-rad10.jpg' },
  { id: 11, thumbnail: '../images/interior-rad/interior-rad11.jpg', fullImage: '../images/interior-rad/interior-rad11.jpg' },
  { id: 12, thumbnail: '../images/interior-rad/interior-rad12.jpg', fullImage: '../images/interior-rad/interior-rad12.jpg' },
  { id: 13, thumbnail: '../images/interior-rad/interior-rad13.jpg', fullImage: '../images/interior-rad/interior-rad13.jpg' },
  { id: 14, thumbnail: '../images/interior-rad/interior-rad14.jpg', fullImage: '../images/interior-rad/interior-rad14.jpg' },
  { id: 15, thumbnail: '../images/interior-rad/interior-rad15.jpg', fullImage: '../images/interior-rad/interior-rad15.jpg' },
  { id: 16, thumbnail: '../images/interior-rad/interior-rad16.jpg', fullImage: '../images/interior-rad/interior-rad16.jpg' },
  { id: 17, thumbnail: '../images/interior-rad/interior-rad17.jpg', fullImage: '../images/interior-rad/interior-rad17.jpg' },
  { id: 18, thumbnail: '../images/interior-rad/interior-rad18.jpg', fullImage: '../images/interior-rad/interior-rad18.jpg' },
  { id: 19, thumbnail: '../images/interior-rad/interior-rad19.jpg', fullImage: '../images/interior-rad/interior-rad19.jpg' },
  // Add more images as needed
];

function InteriorRad() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/interior-designs');
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : interiorRadImages.length - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex < interiorRadImages.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImageIndex !== null) {
        if (event.key === 'ArrowLeft') {
          handlePrev();
        } else if (event.key === 'ArrowRight') {
          handleNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex]);

  return (
    <div className="project-detail">
      <button className="back-button" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>
      <div className="project-detail-grid">
        {interiorRadImages.map((image, index) => (
          <div key={image.id} className="project-detail-item">
            <img
              src={image.thumbnail}
              alt={`Interior Rad Image ${index + 1}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      <button className="back-button back-button-end" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>

      {selectedImageIndex !== null && (
        <div className="project-popup" onClick={handleClose}>
          <div className="project-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>X</button>
            <button className="nav-button left" onClick={handlePrev}>&lt;</button>
            <img src={interiorRadImages[selectedImageIndex].fullImage} alt={`Interior Rad Image ${selectedImageIndex + 1}`} />
            <button className="nav-button right" onClick={handleNext}>&gt;</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default InteriorRad;
